export enum PhoneType {
  Mobile = 'Mobile',
  Home = 'Home',
  Work = 'Work'
}